import React from 'react';
import { SectionLabel } from './SectionLabel';
import { AccordionGroup, AccordionRow } from './Accordion';
import { questions } from '../data/questions';
export function Questions() {
  return <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-57" data-mp="33bzvty30vgal">
      <SectionLabel title="Questions" className="mb-12 md:mb-16" data-id="element-58" data-mp="38bvzfw7t55pm" />

      <AccordionGroup data-id="element-59" data-mp="3899jp9arjjwb">
        {questions.map(item => <AccordionRow key={item.title} title={item.title} body={item.body} data-id="element-60" data-mp="3da79o820li8d" />)}
      </AccordionGroup>
    </section>;
}